// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import HistorySvg from '@rsuite/icon-font/lib/time/History';
var History = createSvgIcon({
  as: HistorySvg,
  ariaLabel: 'history',
  category: 'time',
  displayName: 'History'
});
export default History;